import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "./Constant";

const axiosClient = axios.create({
    baseURL: baseUrl,
});

// Request interceptor to add token and handle common logic
axiosClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - only handles auth expiry (401)
axiosClient.interceptors.response.use(
    (response) => {
        // Do NOT show global success toast here.
        // Each component shows its own success/error toasts.
        return response;
    },
    (error) => {
        const status = error.response?.status;
        const errorMessage = error.response?.data?.message || error.message || "An unexpected error occurred";

        console.error("Axios Error:", { status, errorMessage, path: window.location.pathname });

        if (status === 401) {
            // Token expired or invalid — force logout
            localStorage.clear();
            if (!window.location.pathname.includes('/login')) {
                toast.error("Session expired. Please log in again.");
                window.location.href = `${process.env.PUBLIC_URL}/login`;
            }
        }
        // For all other errors (400, 403, 500, network etc.)
        // let the calling component handle and display the error.
        return Promise.reject(error);
    }
);

export default axiosClient;
